/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("addseatModule", [

]).
controller("addseatCtrl", ["$scope", '$modalInstance', 'trsHttpService',"$document", "$timeout", '$validation', 'addEditService', 'result','modalDialog',
    function($scope, $modalInstance, trsHttpService, $document, $timeout, $validation, addEditService, result,modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            pageNo: 0,
            pageSize: 10,                       
            seatShow: result.MAPCONTROLID.POSTYPE=="2"?false:true, //位置显示
            postype: '', //位置参数
            determineNum:false,//
        };

        if (result.MAPCONTROLID.ID != undefined) {
            if (result.MAPCONTROLID.POSTYPE == '1') {
                $scope.data = {
                    personsName: result.MAPCONTROLID.NAME, //人员姓名
                    specialUsername: result.MAPCONTROLID.NAME8531, //8531用户名
                    personnelDes: result.MAPCONTROLID.INSTRUCTION, //人员描述
                    locationName: '', //位置名称
                    picklocation:'',
                    longitude: '', //经度
                    latitude: '', //纬度
                    locationDescription: '', //位置描述
                    postype: result.MAPCONTROLID.POSTYPE, //位置参数
                    items: result.MAPCONTROLID.MAPCONTROLID, //接收传值
                    isdisplay: result.MAPCONTROLID.DISPLAY, //是否显示                    
                };
            } else {
                $scope.data = {
                    personsName: '', //人员姓名
                    specialUsername: '', //8531用户名
                    personnelDes: '', //人员描述
                    locationName: result.MAPCONTROLID.NAME, //位置名称
                    picklocation:result.MAPCONTROLID.LONGITUDE+','+result.MAPCONTROLID.LATITUDE,
                    longitude: result.MAPCONTROLID.LONGITUDE, //经度
                    latitude: result.MAPCONTROLID.LATITUDE, //纬度
                    locationDescription: result.MAPCONTROLID.INSTRUCTION, //位置描述
                    postype: result.MAPCONTROLID.POSTYPE, //位置参数
                    items: result.MAPCONTROLID.MAPCONTROLID, //接收传值
                    isdisplay: result.MAPCONTROLID.DISPLAY, //是否显示
                };
            }
        } else {
            $scope.data = {
                personsName: '', //人员姓名
                specialUsername: '', //8531用户名
                personnelDes: '', //人员描述
                locationName: '', //位置名称
                picklocation:'',
                longitude: '', //经度
                latitude: '', //纬度
                locationDescription: '', //位置描述
                postype: '', //位置参数
                items: result.MAPCONTROLID, //接收传值
                isdisplay: true, //是否显示
            };
        }       
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {};
   /**
    * 
    */
   $scope.pickUp=function(){
       window.open('http://api.map.baidu.com/lbsapi/getpoint/index.html');
   };
    /**
     * [seatsave description] 保存
     * @return {[type]} [description]
     */
    $scope.seatsave = function() {
        $validation.validate($scope.addLocationData).success(function() {
            if ($scope.status.seatShow == true) $scope.data.postype = 1;
            else $scope.data.postype = 2;
            if($scope.status.determineNum){
                return;
            }
            saveParams();
        });
    };
    /**
     * [saveParams description] 保存服务
     * @return {[type]} [description]
     */
    function saveParams() {
        $scope.status.determineNum=true;
        if ($scope.status.seatShow) { //人员位置
            $scope.params = {
                "typeid": 'screen',
                "serviceid": 'mapPostionMgr',
                "modelid": 'save',
                "postype": $scope.data.postype,
                "name": $scope.data.personsName,
                "name8531": $scope.data.specialUsername,
                "instruction": $scope.data.personnelDes,
                "mapcontrol_id": $scope.data.items,
                "isdisplay": $scope.data.isdisplay,
            };
        } else { //固定位置
            $scope.params = {
                "typeid": 'screen',
                "serviceid": 'mapPostionMgr',
                "modelid": 'save',
                "postype": $scope.data.postype,
                "name": $scope.data.locationName,
                "longitude": $scope.data.picklocation.split(",")[0],
                "latitude":  $scope.data.picklocation.split(",")[1],
                'instruction': $scope.data.locationDescription,
                "mapcontrol_id": $scope.data.items,
                "isdisplay": $scope.data.isdisplay,
            };
        }
        if (result.toChange) {
            $scope.params.id = result.MAPCONTROLID.ID;
        } else {
            delete $scope.params.id;
        }
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
            // if (data.mapResult.status == 'SUCCESS') {                
                modalDialog.alertType("","添加成功！","success",false,function(){
                    $modalInstance.close(true);
                    $timeout(function() {
                        $scope.data.personsName = ''; //人员姓名
                        $scope.data.specialUsername = ''; //8531用户名
                        $scope.data.personnelDes = ''; //人员描述
                        $scope.data.locationName = ''; //位置名称
                        $scope.data.longitude = ''; //经度
                        $scope.data.latitude = ''; //纬度
                        $scope.data.locationDescription = ''; //位置描述       
                        $scope.data.picklocation='';                 
                    }, 1000);
                });              
            // }else{
            //     trsconfirm.alertType('','请填写正确的8531用户名','error');
            // }
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        // addEditService.del();
        $modalInstance.dismiss();
        $scope.data.personsName = ''; //人员姓名
        $scope.data.specialUsername = ''; //8531用户名
        $scope.data.personnelDes = ''; //人员描述
        $scope.data.locationName = ''; //位置名称
        $scope.data.longitude = ''; //经度
        $scope.data.latitude = ''; //纬度
        $scope.data.locationDescription = ''; //位置描述
    };
}]);